import { render, staticRenderFns } from "./userv.vue?vue&type=template&id=339e4ab9&"
import script from "./userv.vue?vue&type=script&lang=js&"
export * from "./userv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports